<template>
    <v-icon :size="size" :class="classes" :color="color">mdi-minus-box-outline</v-icon>
</template>

<script>

  export default {
    name: 'IconNotFound',
    props: {
      size: { Type: Number, default: 24 },
      color: { Type: String, default: '#b2b2b2' },
      classes: { Type: String, default: '' }
    }
  }
</script>
